module.exports = __webpack_public_path__ + "img/header_logo.f2975d3b.png";